<template>
<div class="page-wrapper">
  <Tabs  v-model="current" :animated="false">
    <TabPane name="sj" label="商机" v-if="p('business/list')">
      <read-business></read-business>
    </TabPane>
    <TabPane name="yftx" label="有房提醒" v-if="p('idelHouseRemind/getList')">
      <room-remind></room-remind>
    </TabPane>
    <TabPane name="ptlb" label="拼团列表" v-if="p('idelHouseRemind/getList')">
      <group-manage></group-manage>
    </TabPane>
  </Tabs>
</div>
</template>

<script>
  import readBusiness from'./readBusiness/index'  ;
  import roomRemind from './roomRemind/index'
  import groupManage from './groupManage/index'
  import {mixin} from "../../mixin";

  export default {
    name:'business',
    components:{
      readBusiness,
      roomRemind,
      groupManage
    },
    mixins:[mixin],
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
